/**
 * Error codes for subscription-related errors
 * These codes are shared between backend and frontend to ensure alignment
 */

export const ERROR_CODES = {
	// Subscription limit errors - HTTP 403
	SUBSCRIPTION_FORM_CREATION_LIMIT: "SUBSCRIPTION_FORM_CREATION_LIMIT",
	SUBSCRIPTION_APPLICATION_SUBMISSION_LIMIT:
		"SUBSCRIPTION_APPLICATION_SUBMISSION_LIMIT",
	LINK_INVALID: "LINK_INVALID",
	LINK_ALREADY_USED: "LINK_ALREADY_USED",
	// LinkedIn authentication errors - HTTP 400
	MISSING_LINKEDIN_INFO: "MISSING_LINKEDIN_INFO",
	LINKEDIN_EMAIL_ALREADY_TAKEN: "LINKEDIN_EMAIL_ALREADY_TAKEN",
	EMAIL_DOMAIN_NOT_ALLOWED: "EMAIL_DOMAIN_NOT_ALLOWED",
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];

/**
 * Type guard to check if an error code is a subscription limit error
 */
export const isSubscriptionLimitError = (code: unknown): boolean => {
	return (
		code === ERROR_CODES.SUBSCRIPTION_FORM_CREATION_LIMIT ||
		code === ERROR_CODES.SUBSCRIPTION_APPLICATION_SUBMISSION_LIMIT
	);
};
